import { apiSlice } from '../apiSlice';

export interface ChangePasswordResponse {
  success: boolean;
  message: string;
}

export interface ChangePasswordPayload {
  oldPassword: string;
  newPassword: string;
}

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    changePassword: builder.mutation<ChangePasswordResponse, ChangePasswordPayload>({
      query: (payload) => ({
        url: '/admin/change-password',
        method: 'POST',
        body: payload,
      }),
      invalidatesTags: ['Auth'],
    }),
  }),
});

export const { useChangePasswordMutation } = authApi;
